import React from 'react'

const Mensaje = () => {
    return ( <p>Agrega la cantidad de tu prestamo y el plazo a pagar, por favor.</p> );
}
 
export default Mensaje;